<template>
  <div class="d-flex-row space-between height-max-content why_we_cheap">
    <p class="t-white regular-m font-family-2">
      {{ $t("app.cheap_boost_1")
      }}<span class="bold-m">{{ price }}{{ user.getUserCurrencyCode }}</span
      >{{ $t("app.cheap_boost_2")
      }}<span class="bold-m underline cursor-pointer" @click="toggleOpen">{{
        $t("app.cheap_boost_3")
      }}</span>
    </p>

    <img src="/images/piggy_bank.webp" alt="piggy_bank" class="piggy_bank" />
  </div>

  <Modal :toggle="toggleOpen" :is-open="isOpen">
    <div class="why_we_cheap_modal">
      <div class="d-flex-column gap-0">
        <button @click="closeModal" class="align-self-end">
          <CrossIcon />
        </button>
        <h4 class="t-white font-family-1 title-h4 f-w-600 text-center">
          {{ $t("app.why_we_cheap_head") }}
        </h4>
      </div>

      <div
        class="d-flex-row space-between content xl-row-to-col height-max-content gap-40"
      >
        <div
          class="d-flex-column flex-4 cheap_reason gap-18"
          v-for="reason in reasons"
          :key="reason.id"
        >
          <img
            :src="reason.image"
            alt="reason_image"
            class="reason_image"
            v-if="reason.showImage"
          />
          <div class="price_comparison_container" v-else-if="!reason.showImage">
            <div class="price_items">
              <div class="price_item">
                <div class="price_description">
                  <img
                    src="/images/logo-mobile.webp"
                    alt="mobile_logo"
                    class="platform_logo"
                    height="38"
                    width="41"
                  />
                  <p class="t-orange font-family-2 bold-xl">
                    {{ user.getUserCurrencyCode
                    }}{{ parseFloat(genericStore.getBasePrice).toFixed(2) }}
                  </p>
                </div>
              </div>
              <div class="price_item">
                <div class="price_description_other">
                  <img
                    src="/images/cheap/poop_logo.webp"
                    alt="mobile_logo"
                    class="platform_logo"
                    height="54"
                    width="54"
                  />
                  <p class="t-danger font-family-2 bold-xl">
                    {{ user.getUserCurrencyCode }}{{ otherPrice }}
                  </p>
                </div>
              </div>
            </div>

            <div class="comparison_title">
              <div class="d-flex-row flex-5">
                <img
                  src="/images/cheap/bm_chip.webp"
                  alt="price_chip"
                  class="price_chip"
                />
              </div>
              <div class="d-flex-row flex-5">
                <img
                  src="/images/cheap/ow_chip.webp"
                  alt="price_chip"
                  class="price_chip"
                />
              </div>
            </div>
          </div>
          <div class="d-flex-column justify-start align-start gap-9">
            <div class="d-flex-row justify-start gap-18">
              <label class="t-time font-family-2 medium-s">
                0{{ reason.id }}
              </label>
              <h6
                class="t-white font-family-2 bold-xl"
                v-html="reason.title"
              ></h6>
            </div>
            <p
              class="t-light font-family-2 regular-l"
              style="padding-left: 31px"
            >
              {{ reason.description }}
            </p>
          </div>
        </div>
      </div>

      <div class="d-flex-row height-max-content">
        <button
          class="dark tab medium height-42 full-width max-width-302px _plain b-radius-6 font-family-1 body-m t-white f-w-600"
          @click="closeModal"
        >
          {{ $t("app.close") }}
        </button>
      </div>
    </div>
  </Modal>
</template>

<script setup>
import Modal from "../common/Modal.vue";
import CrossIcon from "../icons/CrossIcon.vue";
import Cookies from "js-cookie";
import { calculateCurrency } from "~/calculate/calculatePrice";

const isOpen = ref(false);
const genericStore = useGenericStore();

const randValue = ref(0);

const { t } = useI18n();
const user = useUserStore();

const reasons = computed(() => {
  return [
    {
      id: 1,
      title: t("app.why_we_cheap_1_head"),
      description: t("app.why_we_cheap_1_detail"),
      image: "/images/cheap/first.webp",
      showImage: true,
    },
    {
      id: 2,
      title: t("app.why_we_cheap_2_head"),
      description: t("app.why_we_cheap_2_detail"),
      image: "/images/cheap/second.webp",
      showImage: true,
    },
    {
      id: 3,
      title: `${t("app.why_we_cheap_3_head_1")} <span class="t-red">${
        price.value
      }${user.getUserCurrencyCode}</span> ${t("app.why_we_cheap_3_head_2")}`,
      description: t("app.why_we_cheap_3_detail"),
      image: "/images/cheap/third.webp",
      showImage: false,
    },
  ];
});

const toggleOpen = () => {
  isOpen.value = !isOpen.value;
  toggleBodyScroll(isOpen.value);
};
const closeModal = () => {
  isOpen.value = false;
  toggleBodyScroll(isOpen.value);
};

const fetchData = async () => {
  try {
    const minValue = 40;
    const maxValue = 80;
    const maxDifference = 10;
    let previousValue = Cookies.get("bm_cal_per") || null;
    let randomValue = previousValue;
    if (!previousValue) {
      // Math.floor(Math.random() * (80 - 40 + 1)) + 40;
      randomValue =
        Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
    }
    const in1Minute = 1 / (24 * 60);
    Cookies.set("bm_cal_per", randomValue, { expires: in1Minute });
    randValue.value = parseInt(randomValue);
  } catch (error) {
    console.log(error);
  }
};

const price = computed(() => {
  const basePrice = genericStore.getBasePrice;
  const priceWithPercentage = (randValue.value / 100) * basePrice;

  const pr = calculateCurrency(priceWithPercentage);
  return parseFloat(pr).toFixed(2);
});

const otherPrice = computed(() => {
  const basePrice = genericStore.getBasePrice;
  return parseFloat(parseInt(price.value) + basePrice).toFixed(2);
});

onNuxtReady(() => {
  fetchData();
});
</script>
